export enum FeatureFlag {
	DisableRightSignature = 'disable-rightsignature',
	EnableBillingAutocomplete = 'enable_billing_autocomplete',
	EnableFailedCCBlock = 'enable-failed-cc-block',
	EnableInternationalEcomm = 'enable_international_ecomm',
	EnableInvoiceOverduePage = 'enable-invoice-overdue-page',
	EnableManagePlanOptimization = 'enable_manage_plan_optimization',
	EnablePaymentGatewayV2 = 'enable_payment_gateway_v2',
	PlannedBillingDowntime = 'planned_billing_downtime',
	UsePiletPageForCancelAccount = 'use-pilet-page-for-cancel-account',
}
